import * as CookieConsent from "vanilla-cookieconsent";
import 'vanilla-cookieconsent/dist/cookieconsent.css';


console.log('CookieConsent loaded');
// Run cookies if it is alowed from config
if (window.cookieConsentEnabled) {
    CookieConsent.run({

        categories: {
            necessary: {
                enabled: true,  // this category is enabled by default
                readOnly: true  // this category cannot be disabled
            },
            analytics: {}
        },

        language: {
            default: 'cs',
            translations: {
                cs: {
                    consentModal: {
                        title: 'Využíváme cookies',
                        description: 'Rezervační systém využívá cookies, které nám pomáhají zlepšovat naše služby a analyzovat návštěvnost.',
                        acceptAllBtn: 'Přijmout vše',
                        acceptNecessaryBtn: 'Přijmout pouze nezbytné',
                        showPreferencesBtn: 'Spravovat preference',
                    },
                    preferencesModal: {
                        title: 'Spravovat preference cookies',
                        acceptAllBtn: 'Přijmout vše',
                        acceptNecessaryBtn: 'Přijmout pouze nezbytné',
                        savePreferencesBtn: 'Uložit preference',
                        closeIconLabel: 'Zavřít',
                        sections: [
                            {
                                title: 'Nezbytné cookies',
                                description: 'Tyto cookies jsou nezbytné pro správné fungování webu a nelze je vypnout. Tyto cookies slouží například k udržení obsahu košíku nebo k zajištění bezpečnosti webu.',
                            },

                        ]
                    }
                }
            }
        }
    });
}
